export default "./dist/stdassets/images/icons/PoweredBy_en.png";